import React from "react";
import { Container, Row, Col, Badge, Button } from "react-bootstrap";
import { projectsList } from "../Utils/Data";

export const Project = () => {
  return (
    <>
      <Container className="mt-5">
        <h2 className="color-custom-blue ml-lg-5 proj-slide">
          Academic projects
        </h2>
        {projectsList.map((proj) => (
          <Row
            className="my-5 px-md-5 proj-opacity"
            xs={1}
            md={2}
            key={proj.label}
          >
            <Col>
              <img
                className="img-fluid proj-image shadow"
                src={proj.imgSrc}
                alt={proj.label}
                loading="lazy"
              />
            </Col>
            <Col className="pt-2">
              <h3 className="font-weight-bold color-custom-blue mb-0">
                {proj.label}
              </h3>
              <br />
              {proj.description && (
                <>
                  <span>{proj.description}</span>
                  <br />
                </>
              )}
              {proj.src && (
                <>
                  <Button
                    className="bg-custom-blue  shadow-sm border-0 resume-btn"
                    onClick={() => window.open(`${proj.src}`)}
                    style={{ borderRadius: "10px", margin: "10px" }}
                  >
                    Live
                  </Button>
                </>
              )}
              {proj.githubSrc && (
                <>
                  <Button
                    className="bg-custom-primary  shadow-sm border-0 resume-btn"
                    onClick={() => window.open(`${proj.githubSrc}`)}
                    style={{ borderRadius: "10px", margin: "10px" }}
                  >
                    Source code
                  </Button>
                  <br />
                </>
              )}
              <div className="mt-2">
                {proj.stack.map((obj) => (
                  <Badge pill variant="secondary" className="mr-1">
                    {obj}
                  </Badge>
                ))}
              </div>
            </Col>
          </Row>
        ))}
      </Container>
    </>
  );
};
